import axios from 'axios';
import { getDashboardApiBase } from '@/lib/dashboardApi';
import { getMasterAgentApiBase } from '@/lib/reportHtml';

/**
 * SM21 monitor lives on master-agent; browsers reach it via dashboard BFF on API Gateway
 * (/backend/api/dashboard/basis/sm21/monitor). Local dev may still hit master directly.
 */
function monitorBaseUrl() {
  const dashboard = (getDashboardApiBase() || '').replace(/\/$/, '');
  if (dashboard) {
    return `${dashboard}/basis/sm21/monitor`;
  }
  const master = (getMasterAgentApiBase() || '').replace(/\/$/, '');
  if (master) {
    return `${master}/basis/sm21/monitor`;
  }
  throw new Error(
    'SM21 monitor API is not configured. Set REACT_APP_BACKEND_URL (or REACT_APP_DASHBOARD_API_URL).',
  );
}

export async function fetchBasisSm21MonitorSettings() {
  const { data } = await axios.get(monitorBaseUrl());
  return data;
}

export async function saveBasisSm21MonitorSettings(patch) {
  const { data } = await axios.put(monitorBaseUrl(), patch);
  return data;
}

export async function fetchBasisSm21Runs({ limit = 50, offset = 0 } = {}) {
  const { data } = await axios.get(`${monitorBaseUrl()}/runs`, {
    params: { limit, offset },
  });
  return data;
}

export async function triggerBasisSm21Run() {
  const { data } = await axios.post(`${monitorBaseUrl()}/runs/trigger`);
  return data;
}

export const SM21_POLL_LABELS = {
  1: 'Hourly',
  4: 'Every 4 hours',
  6: 'Every 6 hours',
  12: 'Every 12 hours',
  24: 'Every 24 hours',
};
